import {
  ComponentProps,
  createElement,
  forwardRef,
  FunctionComponent,
} from "react";

const LinkIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 8",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ createElement("path", {
      fill: "currentColor",
      d: "M4 8c-1.107 0-2.05-.39-2.83-1.17C.39 6.05 0 5.107 0 4s.39-2.05 1.17-2.83C1.95.39 2.893 0 4 0h2.4c.227 0 .417.077.57.23.153.153.23.343.23.57a.773.773 0 0 1-.23.57.775.775 0 0 1-.57.23H4c-.667 0-1.233.233-1.7.7A2.314 2.314 0 0 0 1.6 4c0 .667.233 1.233.7 1.7.467.467 1.033.7 1.7.7h2.4c.227 0 .417.077.57.23.153.153.23.343.23.57a.773.773 0 0 1-.23.57.775.775 0 0 1-.57.23H4Zm1.6-3.2a.772.772 0 0 1-.57-.23A.772.772 0 0 1 4.8 4c0-.227.077-.417.23-.57a.773.773 0 0 1 .57-.23h4.8c.227 0 .417.077.57.23.153.153.23.343.23.57a.773.773 0 0 1-.23.57.775.775 0 0 1-.57.23H5.6Zm4 3.2a.772.772 0 0 1-.57-.23.772.772 0 0 1-.23-.57c0-.227.077-.417.23-.57a.773.773 0 0 1 .57-.23H12c.667 0 1.233-.233 1.7-.7.467-.467.7-1.033.7-1.7s-.233-1.233-.7-1.7a2.314 2.314 0 0 0-1.7-.7H9.6a.772.772 0 0 1-.57-.23A.772.772 0 0 1 8.8.8c0-.227.077-.417.23-.57A.773.773 0 0 1 9.6 0H12c1.107 0 2.05.39 2.83 1.17C15.61 1.95 16 2.893 16 4s-.39 2.05-1.17 2.83C14.05 7.61 13.107 8 12 8H9.6Z",
    })
  );
};

const ForwardRef = forwardRef(LinkIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
